export const SECONDS_IN_DAY = 24 * 60 * 60;
